import styled, { css } from 'styled-components';
import { COLOR_GRAY_30 } from 'styles/variables/colors';

export const Container = styled.div`
  position: relative;

  ${(props) => css`
    margin-bottom: ${props.marginBottom}px;
  `}
`;

export const Select = styled.select`
  border: 1px solid #e0e0e0;
  appearance: none;
  width: 100%;
  display: block;
  padding: 14px 14px 14px 50px;
  border-radius: 4px;
  background-color: #fff;
`;

export const Label = styled.label`
  position: absolute;
  font-size: 0.75rem;
  font-weight: bold;
  left: 10px;
  top: -9px;
  background: white;
  padding: 3px;
`;

export const IconLeftContainer = styled.div`
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  color: ${COLOR_GRAY_30};
`;

export const IconRightContainer = styled.div`
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  color: ${COLOR_GRAY_30};
`;
